<template>
  <div
    v-if="show"
    class="d-flex align-items-center justify-content-center w-100 base-loading"
  >
    <base-text
      size="m"
      light
    >
      {{ label }}
    </base-text>
    <font-awesome-icon
      class="ml-1"
      icon="spinner"
      spin
    />
  </div>
</template>
<script>
export default {
  name: 'BaseLoading',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Loading',
    },
  },
};
</script>
